import React from 'react';
import styled from 'styled-components';
import Colors from '../../styles/colors';
import isEmpty from 'lodash/isEmpty';

const SuccessCharge = (props) => {
  const { plan, onContinue = () => {}, buttonText = '' } = props;

  return (
    <SuccessPayment className="padding-five text-center">
      <img src="../images/success-icon.png" alt="success"/>
      <h1 className="title-large">Your payment was successful</h1>
      <p className="text-large">
        Your plan has been successfully updated to <strong>{plan.toUpperCase()}</strong>.
      </p>
      <button
        onClick={onContinue}
        className="btn text-white padding-ten-left padding-ten-right"
      >
        {isEmpty(buttonText) ? 'Continue' : buttonText}
      </button>
    </SuccessPayment>
  );
};

const SuccessPayment = styled.div`
  img {
    width: 130px;
  }

  button {
    height: 46px;
    background-color: ${Colors.mainOrange};
    font-size: 1.4rem;
    margin-top: 15px;
    margin-bottom: 15px;
  }
`;

export default SuccessCharge;
